var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"division-row"},[_c('img',{attrs:{"src":_vm.img}}),_c('div',[_c('span',{style:({background: _vm.bgColor})},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }